export default __webpack_public_path__ + "static/media/get-in-touch-images.377d86f5.png";